var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomVideoCamera = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.865 15.317c-.257-.44-.862-.616-1.358-.335l-3.286 1.831-.844.476v4.384l.77.44c.037 0 .037.035.056.035l3.23 1.796a.959.959 0 0 0 .551.158c.551 0 .973-.422.973-.933v-3.715l.037-3.662c.018-.158 0-.334-.129-.475z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.645 13.908c2.57 0 4.644-1.989 4.644-4.454S10.215 5 7.645 5C5.075 5 3 6.99 3 9.454c-.036 2.465 2.075 4.454 4.645 4.454zm0-6.285c1.065 0 1.91.828 1.91 1.831 0 1.021-.864 1.831-1.91 1.831-1.046 0-1.91-.827-1.91-1.83-.036-1.022.827-1.832 1.91-1.832z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.412 14.155c-.752.352-1.597.58-2.478.58a5.54 5.54 0 0 1-3.01-.862h-3.287a5.646 5.646 0 0 1-3.01.863c-.9 0-1.726-.194-2.479-.581a2.133 2.133 0 0 0-1.12 1.849v6.76C4.029 24.014 5.094 25 6.36 25h11.877c1.304 0 2.332-1.021 2.332-2.236v-6.76c-.019-.758-.478-1.48-1.157-1.85z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.934 13.908c2.57 0 4.644-1.989 4.644-4.454S19.504 5 16.934 5c-2.57 0-4.645 1.99-4.645 4.454 0 2.465 2.075 4.454 4.645 4.454zm0-6.285c1.065 0 1.91.828 1.91 1.831 0 1.021-.864 1.831-1.91 1.831-1.046 0-1.91-.827-1.91-1.83 0-1.022.845-1.832 1.91-1.832z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomVideoCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-video-camera.40adef60ab91fc9796767d70a379a632.svg";